/**
 * Created by tomers on 12/24/2014.
 */
define(function (require) {
    "use strict";

    //<editor-fold desc="require-region">
    /*-----------------------------------------------------------------------------------------------*/
    var Marionette = require("marionette");
    var Logger = require("logger");

    //Template
    var template = require("ui/list/templates/listGroup.tmpl");

    //List MVC
    var ListItemView = require("ui/list/js/views/ListItemView");

    var NO_ITEMS_ID;
    var NEW_ITEM_ID;
    var HIDE_CLASS_NAME = "hide";
    var COLLAPSIBLE_CLASS_NAME = "collapsible";
    var OPEN_LIST_CLASS_NAME = "group-open";

    //</editor-fold>

    var ListGroupView = Marionette.CompositeView.extend({

        //<editor-fold desc="extended definitions">
        /*-----------------------------------------------------------------------------------------------*/
        tagName: "li",
        className: "list-group-container",
        template: template,
        itemView: ListItemView,
        itemViewContainer: "ul.list-group-items-container",
        ui: {
            titleContainer: ".list-group-title-container",
            title: ".list-group-title-container .title-container",
            arrow: ".list-group-title-container .arrow",
            itemsContainer: ".list-group-items-container"
        },
        events: {
            "click .list-group-title-container": "_onTitleClick"
        },
        itemEventsOld: {
            "itemview:mouseenter": "_onItemMouseEnter",
            "itemview:mouseleave": "_onItemMouseLeave",
            "itemview:click": "_onItemClick",
            "itemview:action-add-click": "_onItemActionAddClick",
            "itemview:action-select-click": "_onItemActionSelectClick",
            "itemview:action-remove-click": "_onItemActionRemoveClick"
        },
        //</editor-fold>


        //<editor-fold desc="Marionette-Functions">
        /*-----------------------------------------------------------------------------------------------*/
        initialize: function (options) {
            this._initialize(options);
        },
        itemViewOptions: function(model) {
            return this._itemViewOptions(model);
        },
        onRender: function () {
            this._onRender();
        },
        //</editor-fold>

        //<editor-fold desc="publicFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        setError: function(isError, msg) {
            this._setError(isError, msg);
        },

        //</editor-fold>

        //<editor-fold desc="privateFunctions">
        /*-----------------------------------------------------------------------------------------------*/
        _initialize: function (options) {
            this.logger = Logger.getLogger("List");
            this.logger.info("Initializing List Group View", "ListGroupView:_initialize", {options:options});
            this.model = options.model;
            this.collection = this.model.getItems();
            this.hasCheckbox = options.hasCheckbox;
            this.isNightTheme = options.isNightTheme;

            Marionette.bindEntityEvents(this, this, this.itemEventsOld);
        },

        _itemViewOptions: function(model) {
            var isSpecialGroup = this.model.isSpecialGroup();
            return {
                model: model,
                hasCheckbox: this.hasCheckbox && !isSpecialGroup,
                isNightTheme: this.isNightTheme
            };
        },

        _onRender: function () {
            this.logger.info("Rendering List Group View", "ListGroupView:_onRender");

            this._updateClassName();

            this._updateTitle();
            this._updateTitleVisibility();
            this._updateGroupCollapsible();
            this._toggleGroupOpenClass();
        },

        _updateClassName: function() {
            this.$el.addClass(this.model.getClassName());
        },

        _updateTitle: function () {
            this.ui.title.text(this.model.id);
        },
        _updateTitleVisibility: function () {
            this.ui.titleContainer.toggleClass(HIDE_CLASS_NAME, !this.model.isTitleVisible());
        },
        _updateGroupCollapsible: function () {
            this.ui.titleContainer.toggleClass(COLLAPSIBLE_CLASS_NAME, this.model.isGroupCollapsible());
        },
        _toggleGroupOpenClass: function() {
            this.$el.toggleClass(OPEN_LIST_CLASS_NAME);
        },

        _onTitleClick: function(e) {
            this.logger.info("group title was clicked", "ListGroupView:_onTitleClick");

            e.stopPropagation();
            this._toggleGroupOpenClass();
        },

        _onItemMouseEnter: function(itemView) {
            this.trigger("mouseenter", itemView);
        },

        _onItemMouseLeave: function(itemView) {
            this.trigger("mouseleave", itemView);
        },

        _onItemClick: function(itemView) {
            this.logger.debug("list group - item was clicked", "ListGroupView:_onItemClick");
            this.trigger("click", itemView);
        },

        _onItemActionAddClick: function(itemView) {
            this.logger.debug("list group - action clicked - add", "ListGroupView:_onItemActionAddClick");
            this.trigger("action-add-click", itemView);
        },

        _onItemActionSelectClick: function(itemView) {
            this.logger.debug("list group - action clicked - select", "ListGroupView:_onItemActionSelectClick");
            this.trigger("action-select-click", itemView);
        },

        _onItemActionRemoveClick: function(itemView) {
            this.logger.debug("list group - action clicked - remove", "ListGroupView:_onItemActionRemoveClick");
            this.trigger("action-remove-click", itemView);
        },

        _setError: function(isError, msg) {
            this.children.each(function (itemView) {
                itemView.setError(isError, msg);
            });
        }
        //</editor-fold>
    });

    ListGroupView.ListItemView = ListItemView;

    return ListGroupView;

});
